import { Link } from "react-router-dom";
import { STUDIO } from "@/lib/studio";
import { Mark } from "./Mark";

const FLink = ({ to, children }) => (
  <Link to={to} data-testid={`footer-link-${to.slice(1)}`} className="link-underline hover:text-cream">{children}</Link>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-gold-light/15 bg-espresso text-cream">
    <div className="mx-auto grid max-w-7xl gap-8 px-5 py-12 text-center sm:px-8 lg:grid-cols-3 lg:items-center lg:text-left">
      <div className="flex items-center justify-center gap-3 lg:justify-start">
        <Mark className="h-10 w-10" />
        <div className="text-left">
          <p className="font-serif tracking-[0.28em]">MAISON PRINCESS</p>
          <p className="font-script text-xl text-gold-light">Aus Liebe entstanden. Für dich gemacht.</p>
        </div>
      </div>
      <nav aria-label="Footer" className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-cream/80">
        <FLink to="/preisliste">Preisliste</FLink>
        <FLink to="/impressum">Impressum</FLink>
        <FLink to="/datenschutz">Datenschutz</FLink>
        <FLink to="/agb">AGB</FLink>
      </nav>
      <div className="text-xs leading-relaxed text-cream/70 lg:text-right">
        <p>{STUDIO.street} · {STUDIO.city}</p>
        <p>© {new Date().getFullYear()} Maison Princess · Bensheim</p>
      </div>
    </div>
  </footer>
);
